import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { AppSidebar } from './AppSidebar';
import { AppTopbar } from './AppTopbar';
import { AppThemeProvider, useAppTheme } from '@/context/AppThemeProvider';
import './AppLayout.css';

/**
 * Inner layout component that can use the context
 */
const AppLayoutInner: React.FC = () => {
  const { collapseSidebar } = useAppTheme();

  const handleContentClick = () => {
    // Collapse sidebar when clicking on content area
    collapseSidebar();
  };

  return (
    <div className="app-layout">
      {/* Topbar */}
      <AppTopbar />
      
      <div className="app-body">
        {/* Sidebar */}
        <AppSidebar />
        
        {/* Main Content Area */}
        <main className="app-content" onClick={handleContentClick}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

/**
 * AppLayout - Main application layout for StonkFU
 * This replaces UBOLD's layout system with our custom implementation
 * Based on the exact specifications from temp-stonkfu-actual-mockup.html
 */
export const AppLayout: React.FC = () => {
  useEffect(() => {
    // Add class to body to identify when AppLayout is active
    document.body.classList.add('app-layout-active');
    
    // Initialize theme from localStorage
    const savedTheme = localStorage.getItem('stonkfu-theme');
    if (savedTheme === 'dark') {
      document.body.classList.add('dark-theme');
    }
    
    return () => {
      document.body.classList.remove('app-layout-active');
    };
  }, []);

  return (
    <AppThemeProvider>
      <AppLayoutInner />
    </AppThemeProvider>
  );
};

export default AppLayout;